import React, { FC } from 'react';
import { AdvancedSelect } from '../select';
import { PropertiesPanelControl, PropertiesPanelLabel, PropertiesPanelProperty } from './propertiesPanelProperty';

export type PropertiesPanelSelectValue = { value: string | number; label: string } | null | undefined;

export type PropertiesPanelAdvancedSelectPropertyProps = {
    menuPlacement?: 'auto' | 'bottom' | 'top';
};

export type PropertiesPanelSelectPropertyProps = {
    id: string;
    label: React.ReactNode;
    options: NonNullable<PropertiesPanelSelectValue>[];
    value: PropertiesPanelSelectValue;
    onChange: (value: PropertiesPanelSelectValue) => void;
    selectCustomProps?: PropertiesPanelAdvancedSelectPropertyProps;
    disabled?: boolean;
};
export const PropertiesPanelSelectProperty: FC<PropertiesPanelSelectPropertyProps> = ({ id, label, options, value, onChange, disabled, selectCustomProps }) => {
    return (
        <PropertiesPanelProperty>
            <PropertiesPanelLabel htmlFor={`${id}-input`}>{label}</PropertiesPanelLabel>
            <PropertiesPanelControl>
                <AdvancedSelect
                    id={id}
                    options={options}
                    value={value}
                    onChange={(newValue) => {
                        onChange?.(newValue);
                    }}
                    isDisabled={disabled}
                    {...selectCustomProps}
                />
            </PropertiesPanelControl>
        </PropertiesPanelProperty>
    );
};
